import styled, { css } from 'styled-components';

interface ExpandedProps {
	$expanded?: boolean;
	$placeholder?: boolean;
}

interface ListItemProps {
	$selected: boolean;
}

export const Select = styled.div<{ $disabled?: boolean }>`
	height: 50px;
	position: relative;
	box-sizing: border-box;
	border-radius: 12px;
	padding: 12px;
	display: flex;
	width: 100%;
	border-width: 1px;
	border-style: solid;
	border-color: #dbdbdb;
	margin: 0;
	cursor: pointer;
	user-select: none;
	transition: border-color 0.3s;
	background-color: ${({ theme }) => theme.colors.neutral.white};

	&:hover {
		border-color: #ced4da;
	}

	&:focus-within {
		border-color: ${({ theme }) => theme.colors.primary.medium};
	}

	&:focus-visible {
		outline: none;
	}

	${({ $disabled }) =>
		$disabled &&
		css`
			cursor: auto;
			background-color: #dbdbdb;

			&:focus-within {
				border-color: #dbdbdb;
			}
		`}
`;

export const SelectedOption = styled.div<ExpandedProps>`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	color: #999;

	> span {
		color: ${({ $placeholder, theme }) => ($placeholder ? '#999' : theme.colors.neutral.black)};
	}

	> svg {
		transform: rotate(${(props) => (props.$expanded ? '-180deg' : '0deg')});
		transition: transform 0.3s;
	}
`;

export const Options = styled.div<ExpandedProps>`
	display: flex;
	align-items: center;
	justify-content: center;
	position: absolute;
	margin-top: 4px;
	left: 0;
	right: 0;
	top: 100%;
	z-index: 3;
	pointer-events: ${({ $expanded }) => ($expanded ? 'auto' : 'none')};
`;

export const Ul = styled.ul<ExpandedProps>`
	background-color: ${({ theme }) => theme.colors.neutral.white};
	outline: 1px solid white;
	border-radius: 12px;
	list-style: none;
	margin: 0;
	padding: 8px;
	width: 100%;
	max-height: 480px;
	overflow-y: auto;
	overflow-x: hidden;
	opacity: 0;
	transform-origin: top;
	transform: scale(0.75) translateY(-24px);
	transition: all 0.3s cubic-bezier(0.5, 0, 0, 1.25), opacity 0.15s ease-out;
	${({ theme }) => theme.boxShadow.dropdown}

	${({ $expanded }) =>
		$expanded &&
		css`
			opacity: 1;
			transform: scale(1);
		`}
`;

export const Li = styled.li<ListItemProps>`
	padding: 12px;
	border-radius: 12px;
	transition: 0.3s;
	font-weight: ${({ $selected }) => ($selected ? '700' : 'normal')};
	color: ${({ $selected, theme }) => ($selected ? theme.colors.primary.medium : 'inherit')};

	&:hover,
	&:focus {
		outline: none;
		color: ${({ theme }) => theme.colors.primary.medium};
		background-color: ${({ theme }) => theme.colors.primary.lighter};
	}
`;

export const InputContainer = styled.div`
	cursor: text;
	margin-bottom: 8px;
`;
